/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placewebdeselectphoto3Inputs */

const en_placewebdeselectphoto3 = /** @type {(inputs: Placewebdeselectphoto3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deselect photo`)
};

const de_placewebdeselectphoto3 = /** @type {(inputs: Placewebdeselectphoto3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foto abwählen`)
};

/**
* | output |
* | --- |
* | "Deselect photo" |
*
* @param {Placewebdeselectphoto3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placewebdeselectphoto3 = /** @type {((inputs?: Placewebdeselectphoto3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placewebdeselectphoto3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placewebdeselectphoto3(inputs)
	return de_placewebdeselectphoto3(inputs)
});
export { placewebdeselectphoto3 as "placeWebDeselectPhoto" }